import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import Topbar from '../Topbar';
import { getPrivacyPolicyByCountry } from './PrivacyPolicyUtils';
import {
    COUNTRY,
    getCountryConstant,
    getCountryFullName,
} from '../CountryUtils';
import { getPrivacyPolicyPageUrlByCountry } from '../UrlUtils';

const PrivacyPolicyMainPage = (props) => {
    // Default privacy policy page to be displayed would be UK, in case no country param is passed or a random country is passed through the URL for which we do not have any mappings
    const [country, setCountry] = useState(
        props.consultantCountry || getCountryFullName(COUNTRY.UK)
    );
    const location = useLocation();
    const history = useHistory();
    const searchParams = new URLSearchParams(location.search);

    useEffect(() => {
        const countryFromURL = searchParams.get('country');

        if (countryFromURL) {
            // This check is required to avoid any untentional behavior with country which is not presently supported
            if (getCountryConstant(countryFromURL)) {
                setCountry(countryFromURL);
            } else {
                // In case the country is not supported, then re-direct to the UK privacy notice page.
                history.push(getPrivacyPolicyPageUrlByCountry(COUNTRY.UK));
            }
        }
    }, [searchParams]);

    const privacyPolicy = getPrivacyPolicyByCountry(
        getCountryConstant(country)
    );

    const PrivacyPolicyBox = () => (
        <div className="lg:text-justify">{privacyPolicy.element}</div>
    );

    return (
        <div>
            <Topbar title={'Privacy notice for Industry Consultants'} />
            <div className="mt-2 max-w-6xl w-full mx-auto">
                <div
                    className={
                        'w-full overflow-hidden max-w-4xl mx-auto bg-white px-6 py-4 md:mt-6 md:mb-6 border rounded-b shadow-md text-sm'
                    }
                >
                    <PrivacyPolicyBox />
                </div>
            </div>
        </div>
    );
};

PrivacyPolicyMainPage.propTypes = {
    consultantCountry: PropTypes.string,
};

export default PrivacyPolicyMainPage;
